export const TargetPosition = {
  Top: "top",
  Left: "left",
  Bottom: "bottom",
};
